import React from "react";
import changePasswordIllustrationLogo from "./ChangePasswordIllustrationLogo.svg";

function ChangePasswordIllustrationLogoIcon({
  alt = "Change password illustration",
  className = "",
  height = 203,
  width = 165,
}) {
  return (
    <img
      alt={alt}
      className={className}
      height={height}
      src={changePasswordIllustrationLogo}
      width={width}
    />
  );
}

export default ChangePasswordIllustrationLogoIcon;
